export default function CDate() {
  return <h2>C Date</h2>;
}
